<template>
  <div class="columns small-12 medium-12 large-6">
    <h1 v-html="viewModel.receiptHeadline" />
    <p class="push-up" v-html="viewModel.receiptBody" />
    <button
      data-test="partnership-referral-receipt-button"
      class="button large small-12 medium-6 large-6 viewModel.receiptButton.cssClass"
      @click="onReceiptButtonClick"
      v-html="viewModel.receiptButton.text"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { PartnershipReferralReceiptViewModel } from '../types/PartnershipReferral';

export default defineComponent({
  name: 'PartnershipReferralReceipt',
  props: {
    viewModel: {
      type: Object as PropType<PartnershipReferralReceiptViewModel>,
      default() {
        return {
          receiptHeadline: '',
          receiptBody: '',
          receiptButton: {
            url: '',
            text: '',
            cssClass: ''
          }
        };
      }
    }
  },
  methods: {
    onReceiptButtonClick() {
      location.href = this.viewModel.receiptButton.url;
    }
  }
});
</script>
